export default "__VITE_ASSET__e96b67eb__"